import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getCommonUrl } from '../../../components/common/common-functions/commonApiUrl/get-common-url';
import getConfig from '../../../helpers/config';
import {
  CreateKalendariAkademik,
  KalendariAkademik,
  KalendarStatus,
} from '../../../interfaces/calendar';
import {
  PaginationProps,
  PaginationReturn,
} from '../../../interfaces/pagination';
import { getPrepareHeaders } from '../get-prepare-headers';

const { test } = getConfig();

export interface KalendariAkademikParams extends PaginationProps {
  emertimi?: string;
  statusKalendar?: KalendarStatus;
}

export const kalendarApi = createApi({
  reducerPath: 'kalendariAkademikApi',
  baseQuery: fetchBaseQuery({
    baseUrl: test.baseUrl + `/`,
    prepareHeaders: getPrepareHeaders,
  }),
  tagTypes: ['KalendareAkademike', 'KalendariAkademik'],
  endpoints: builder => ({
    getKalendareAkademike: builder.query<
      PaginationReturn<KalendariAkademik>,
      KalendariAkademikParams
    >({
      query: args => ({
        url: getCommonUrl(args, '/kalendar'),
      }),
      providesTags: ['KalendareAkademike'],
    }),

    createKalendariAkademik: builder.mutation<
      void,
      Partial<CreateKalendariAkademik>
    >({
      query: ({ id, ...body }) => ({
        url: id ? `/kalendar/${id}` : '/kalendar',
        method: id ? 'PATCH' : 'POST',
        body,
      }),
      invalidatesTags: (_result, _error, { id }) =>
        id
          ? ['KalendareAkademike', { type: 'KalendariAkademik', id }]
          : ['KalendareAkademike'],
    }),

    deleteKalendariAkademik: builder.mutation<void, number>({
      query: id => ({
        url: `/kalendar/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['KalendareAkademike'],
    }),
  }),
});

export const {
  useGetKalendareAkademikeQuery,
  useLazyGetKalendareAkademikeQuery,
  useCreateKalendariAkademikMutation,
  useDeleteKalendariAkademikMutation,
} = kalendarApi;
